import { createContext } from 'react';

export const EditPageContext = createContext(false);
